import Vue from 'vue';
import Vuex from 'vuex';
import VuexEasyFirestore from 'vuex-easy-firestore';
import fb from '../firebaseConfig';
import router from '../router';

// Import Modules
import auth from './auth';
import contextModule from './database/easyFirestore/context';
import pagesModules from './database/easyFirestore/pages';
import resourcesModules from './database/easyFirestore/resources';
import spacesModule from './database/easyFirestore/workspaces';
import userContextsLiteModule from './database/easyFirestore/userContextsLite';
import userWorkspaceLiteModule from './database/easyFirestore/userWorkspaceLite';
import invitesModule from './database/easyFirestore/invites';
import views from './views/index';
import components from './components/index';
import track from './database/analytics';

// add vuex to vue
Vue.use(Vuex);

// do the magic 🧙🏻‍
const easyFirestore = VuexEasyFirestore(
  [
    contextModule,
    pagesModules,
    spacesModule,
    resourcesModules,
    userContextsLiteModule,
    userWorkspaceLiteModule,
    invitesModule
  ],
  {
    logging: true,
    FirebaseDependency: fb.firebase
  }
);

const storeData = {
  plugins: [easyFirestore],
  modules: {
    auth,
    views,
    components,
    track
  }
};
const store = new Vuex.Store(storeData);

fb.auth.onAuthStateChanged(async user => {
  if (user) {
    store.commit('auth/setCurrentUser', user);
    store.commit('auth/setFetchingUserData', true);
    try {
      await store.dispatch('auth/subscribeToUser');
      await store.dispatch('workspaces/subscribeToWorkspaces');
      await store.dispatch('userWorkspaceLite/subscribeToUserWorkspaceLite');
      store.commit('auth/setFetchingUserData', false);
    } catch (e) {
      console.log(e);
      store.commit('auth/setFetchingUserData', false);
    }
  } else {
    //store.dispatch('userContextsLite/unsubscribeToUserContextsLite');
    store.dispatch('userWorkspaceLite/unsubscribeToUserWorkspaceLite');
    store.dispatch('workspaces/unsubscribeToWorkspaces');
  }
});

export default store;
